<template>
  <v-container :fluid="$vuetify.breakpoint.mdAndDown" class="app-stepper">
    <v-row justify="center">
      <v-col cols="12" md="4" xl="3" v-if="$vuetify.breakpoint.mdAndUp">
        <AdminSidebar />
      </v-col>
      <v-col cols="12" :md="8">
        <ApartmentsList v-if="$route.name === 'Apartments' && $vuetify.breakpoint.smAndDown" />
        <router-view :key="$route.params.id ? $route.params.id : 'no-id'"></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
var Sticky = require("sticky-js");

import ApartmentsList from "@/components/admin/ApartmentsList";
import ApartmentsTable from "@/components/admin/ApartmentsTable";
import AdminSidebar from "@/components/admin/AdminSidebar";
export default {
  components: {
    ApartmentsTable,
    ApartmentsList,
    AdminSidebar,
    ApartmentsList,
  },
  mounted() {
    new Sticky(".sticky", { stickyWrap: true, marginTop: 16, dataStickyFor: 959 /* mdAndUp */ });
  },
};
</script>

